module.exports = __webpack_public_path__ + "toGroom-jp-w-b.54e3c171.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-jp-w-b.jpg
// module id = 6BuT
// module chunks = 0